import React from 'react'
import R from 'ramda'
import { Row, Col } from 'react-bootstrap'
import EditableTable from '_/shared/components/editableTable'
import ensureNumber from '_/utils/ensureNumber'
import { List } from 'immutable'
import TransactionDetail from './transactionDetail'

/**
 * Sale detail page
 */
class SaleDetail extends React.Component {
  static propTypes = {
    account: React.PropTypes.object.isRequired,
    transaction: React.PropTypes.object.isRequired,
    link: React.PropTypes.func.isRequired,
    errors: React.PropTypes.object,
    onCertify: React.PropTypes.func.isRequired,
    metadata: React.PropTypes.object.isRequired,
    editing: React.PropTypes.bool
  }

  constructor (props, context) {
    super(props, context)
    this.state = {
      onCertify: props.onCertify
    }
  }

  render() {
    const { account, metadata, link, transaction, errors, editing } = this.props
    const { onCertify } = this.state

    return (
      <div>
        <Row>
          <Col xs={6}>
            <EditableTable
              title="Sale: Particulars"
              link={link}
              errors={errors}
              editable={editing}
              metadata={metadata}
              account={account}
              onCertify={onCertify}
              data={transaction}
              fields={List([
                'catylistId',
                'saleT',
                'closeDt',
                'saleDt',
                'origListDt',
                'origListPx',
                'onMktDay',
                'acquisTM',
                'concessions',
                'deedT',
                'docNo',
                'leaseFeeT',
                'saleGbaSf',
                'saleLandSf',
                'totalAcreCt'
              ])}
            />

            <EditableTable
              title="Sale: Usage"
              link={link}
              errors={errors}
              editable={editing}
              metadata={metadata}
              account={account}
              onCertify={onCertify}
              data={transaction}
              fields={List([
                'propName',
                'useTM',
                'propUse',
                'commodityTM',
                'tenantsM'
              ])}
            />

            <EditableTable
              title="Sale: Conditions"
              link={link}
              errors={errors}
              editable={editing}
              metadata={metadata}
              account={account}
              onCertify={onCertify}
              data={transaction}
              fields={List([
                'detriCond'
              ])}
            />

            <EditableTable
              title="Sale: Buyer information"
              link={link}
              errors={errors}
              editable={editing}
              metadata={metadata}
              account={account}
              onCertify={onCertify}
              data={transaction}
              fields={List([
                'buyer',
                'buyerAgt',
                'buyerAgtEm',
                'buyerAgtPn',
                'trueByr',
                'trueByrAdr',
                'trueByrEm',
                'trueByrPn'
              ])}
            />
          </Col>
          <Col xs={6}>
            <EditableTable
              title="Sale: Considerations"
              link={link}
              errors={errors}
              editable={editing}
              metadata={metadata}
              account={account}
              onCertify={onCertify}
              data={transaction}
              fields={List([
                'salePx',
                'assessPx',
                'persPropPx',
                'totalPx',
                'transFeePx',
                'perSfPx',
                'perAcrePx',
                'capRtPct',
                'pxVerifSrc',
                'downPmtPx',
                'financingT',
                'finSrcTM'
              ])}
            />

            <EditableTable
              title="Sale: Gov't values"
              link={link}
              errors={errors}
              editable={editing}
              metadata={metadata}
              account={account}
              onCertify={onCertify}
              data={transaction}
              fields={List([
                'marketPx',
                'taxesPx',
                'taxYr'
              ])}
            />

            <EditableTable
              title="Sale: Unit price"
              link={link}
              errors={errors}
              editable={editing}
              metadata={metadata}
              account={account}
              onCertify={onCertify}
              data={transaction}
              fields={List([
                'unitPx'
              ])}
            />

            <EditableTable
              title="Sale: FF&E"
              link={link}
              errors={errors}
              editable={editing}
              metadata={metadata}
              account={account}
              onCertify={onCertify}
              data={transaction}
              fields={List([
                'ffePx',
                'ffeDesc'
              ])}
            />

            <EditableTable
              title="Sale: Seller information"
              link={link}
              errors={errors}
              editable={editing}
              metadata={metadata}
              account={account}
              onCertify={onCertify}
              data={transaction}
              fields={List([
                'seller',
                'sellerAgt',
                'sellerAgtEm',
                'sellerAgtPn',
                'trueSlr',
                'trueSlrAdr',
                'trueSlrEm',
                'trueSlrPn'
              ])}
            />
          </Col>
        </Row>

        <Row>
          <Col xs={12}>
            <EditableTable
              link={link}
              errors={errors}
              editable={editing}
              metadata={metadata}
              account={account}
              onCertify={onCertify}
              data={transaction}
              fields={List([
                'linksM',
                'remarks',
                'rediRemarks'
              ])}
            />
          </Col>
        </Row>
      </div>
    )
  }
}

export default TransactionDetail(SaleDetail, {
  type: 'sale',
  calcMap: {
    _isVacantOnly (transaction) {
      return transaction.get('properties')
        .every(property => {
          const genUseTM = property.get('genUseTM')
          return genUseTM.size === 1 && genUseTM.indexOf('Vacant Land') !== -1
        })
    },
    assessPx (...args) { this.totalPx(...args) },
    perSfPx (transaction, keyPath, value) {
      const isVacantOnly = this._isVacantOnly(transaction)
      let salePxVal = ensureNumber(transaction.get('salePx'))
      let saleLandSfVal = ensureNumber(transaction.get('saleLandSf'))
      let saleGbaSfVal = ensureNumber(transaction.get('saleGbaSf'))

      switch (R.last(keyPath)) {
        case 'salePx':
          salePxVal = ensureNumber(value)
          break
        case 'saleLandSf':
          saleLandSfVal = ensureNumber(value)
          break
        case 'saleGbaSf':
          saleGbaSfVal = ensureNumber(value)
          break
      }

      if (isVacantOnly) {
        if (salePxVal && saleLandSfVal) {
          transaction.set('perSfPx', (salePxVal / saleLandSfVal).toFixed(2))
        }
      }
      else {
        if (salePxVal && saleGbaSfVal) {
          transaction.set('perSfPx', (salePxVal / saleGbaSfVal).toFixed(2))
        }
      }
    },
    saleGbaSf (...args) { this.perSfPx(...args) },
    saleLandSf (...args) {
      this.perSfPx(...args)
      this._totalAcreCt(...args)
    },
    _saleLandSf (transaction, keyPath, value) {
      const totalAcreCtVal = ensureNumber(value)

      if (totalAcreCtVal) {
        transaction.set(
          'saleLandSf',
          (totalAcreCtVal * 43560).toFixed(2)
        )
      }
    },
    calcSaleSf (transaction, keyPath, value) {
      const isVacantOnly = this._isVacantOnly(transaction)
      const salePxVal = ensureNumber(transaction.get('salePx'))

      if (salePxVal) {
        transaction.set(
          [isVacantOnly ? 'saleLandSf' : 'saleGbaSf'],
          (salePxVal / ensureNumber(value)).toFixed(0)
        )
      }
    },
    totalAcreCt (...args) {
      this._saleLandSf(...args)
      this._perAcrePx(...args)
    },
    _totalAcreCt (transaction, keyPath, value) {
      const saleLandSfVal = ensureNumber(value)

      if (saleLandSfVal) {
        transaction.set(
          'totalAcreCt',
          (saleLandSfVal / 43560).toFixed(2)
        )
      }
    },
    _perAcrePx (transaction, keyPath, value) {
      let totalPxVal = ensureNumber(transaction.get('totalPx'))
      let totalAcreCtVal = ensureNumber(transaction.get('totalAcreCt'))

      switch (R.last(keyPath)) {
        case 'totalPx':
          totalPxVal = ensureNumber(value)
          break
        case 'totalAcreCt':
          totalAcreCtVal = ensureNumber(value)
          break
      }

      if (totalPxVal && totalAcreCtVal) {
        transaction.set(
          'perAcrePx',
          (totalPxVal / totalAcreCtVal).toFixed(2)
        )
      }
    },
    salePx (transaction, keyPath, value) {
      this._totalPx(transaction, keyPath, value)
    },
    totalPx (...args) { this._perAcrePx(...args) },
    _totalPx (transaction, keyPath, value) {
      let salePxVal = ensureNumber(transaction.get('salePx'))
      let assessPxVal = ensureNumber(transaction.get('assessPx'))

      switch (R.last(keyPath)) {
        case 'salePx':
          salePxVal = ensureNumber(value)
          break
        case 'assessPx':
          assessPxVal = ensureNumber(value)
          break
      }

      transaction.set('totalPx',
        salePxVal
          ? (salePxVal + assessPxVal).toFixed(2)
          : (assessPxVal).toFixed(2)
      )
    },
    closeDt (transaction, keyPath, value) {
      this._onMktDay(transaction, keyPath, value)
    },
    origListDt (transaction, keyPath, value) {
      this._onMktDay(transaction, keyPath, value)
    },
    _onMktDay (transaction, keyPath, value) {
      let closeDtVal = transaction.get('closeDt')
      let origListDtVal = transaction.get('origListDt')

      switch (R.last(keyPath)) {
        case 'closeDt':
          closeDtVal = value
          break
        case 'origListDt':
          origListDtVal = value
          break
      }

      if (closeDtVal && origListDtVal) {
        let timeDiff = Math.abs(new Date(closeDtVal).getTime() - new Date(origListDtVal).getTime())
        let diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24))

        transaction.set('onMktDay', diffDays)
      }
    }
  }
})



// WEBPACK FOOTER //
// ./modules/shared/pages/record/saleDetail.js